import { ArrowBack, Delete } from '@mui/icons-material';
import { Box, Divider, Grid, IconButton } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import { PendingRespondent, PendingRespondentStatusMap } from 'src/@types/pendingRespondentStatus';
import { DeleteConfirmModal } from '../../../modal/delete/components/DeleteConfirmModal';
import { IdIssuanceManagementDetailCard } from './IdIssuanceManagementDetailCard';
import { IdIssuanceManagementDetailForm } from './IdIssuanceManagementDetailForm';
import { useIdIssuanceManagementDetail } from './hooks/useIdIssuanceManagementDetail';

type IdIssuanceManagementDetailProps = {
  selectedUser: PendingRespondent;
  setSelectedUser: Dispatch<SetStateAction<PendingRespondent | undefined>>;
  statusMap: PendingRespondentStatusMap;
};

export const IdIssuanceManagementDetail = ({ selectedUser, setSelectedUser, statusMap }: IdIssuanceManagementDetailProps) => {
  const { setIsOpenDeleteConfirm, isOpenDeleteConfirm, onDelete } = useIdIssuanceManagementDetail({ selectedUser, setSelectedUser });

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexDirection: 'row',
          mb: 2,
        }}>
        <IconButton onClick={() => setSelectedUser(undefined)}>
          <ArrowBack />
        </IconButton>
        <IconButton onClick={() => setIsOpenDeleteConfirm(true)} disabled={!selectedUser.canDelete}>
          <Delete />
        </IconButton>
      </Box>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <IdIssuanceManagementDetailCard selectedUser={selectedUser} statusMap={statusMap} />
      </Grid>
      {selectedUser.emailTemplate && (
        <>
          <Divider sx={{ pt: 4, pb: 4 }} />
          <Box sx={{ p: 2, mt: 2, mb: 2 }}>
            <IdIssuanceManagementDetailForm selectedUser={selectedUser} setSelectedUser={setSelectedUser} />
          </Box>
        </>
      )}
      <DeleteConfirmModal isOpen={isOpenDeleteConfirm} disagreeCallback={() => setIsOpenDeleteConfirm(false)} agreeCallback={onDelete} />
    </>
  );
};
